<script>
  import Player from "./Player.svelte";
  export let self;
  export let otherPlayers;
</script>

<style>
  .player-list {
    display: flex;
  }
</style>

<div class="player-list">
  {#if self}
    <Player
      name={self.name}
      color={self.hues[1]}
      highlightColor={self.hues[0]}
      editable={true} />
  {/if}
  {#each otherPlayers as player}
    <Player
      name={player.name}
      color={player.hues[1]}
    />
  {/each}
</div>
